import { routes } from "schemas/routes";

export function getOnboardingPage(currentPathname: string) {
  if (currentPathname.endsWith(routes.preferencesOnboarding)) {
    return "preferencesForm";
  } else if (currentPathname.endsWith(routes.aboutOnboarding)) {
    return "aboutForm";
  } else if (currentPathname.endsWith(routes.categoryOnboarding)) {
    return "categoryForm";
  } else if (currentPathname.endsWith(routes.paywallOnboarding)) {
    return "paywall";
  }
}

export const getOnboardingSteps = (
  isSocialFlow: boolean,
  isExperimentPaywall: boolean,
  currentPath: string,
) => {
  let currentFlow = [routes.aboutOnboarding, routes.categoryOnboarding];

  if (isSocialFlow) {
    // Insert social onboarding steps at the beginning of the array
    currentFlow.unshift(routes.preferencesOnboarding);
  } else if (isExperimentPaywall) {
    // Insert paywall onboarding at the beginning of the array
    currentFlow.unshift(routes.paywallOnboarding);
  }

  let stepNumber = currentFlow.findIndex((step) => currentPath.includes(step));

  if (stepNumber > -1) {
    stepNumber += 1;
  }

  return { steps: currentFlow, currentStep: stepNumber };
};
